import { createAction, props } from '@ngrx/store';
import { QueryOptions } from '@mkp/shared/util-pagination';

export const reset = createAction(`[User List] Reset`);
export const init = createAction(`[User List] Init`, props<{ query: QueryOptions }>());
export const loadMore = createAction(`[User List] Load More`, props<{ query: QueryOptions }>());
